import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import type { DatasetView } from '../types';

interface DatasetViewToggleProps {
  view: DatasetView;
  onChange: (view: DatasetView) => void;
  listLabel: string;
  tableLabel: string;
}

const toggleButtonSx = {
  height: '30px',
  padding: '3px 9px',
  fontSize: '13px',
  textTransform: 'none' as const,
};

// Always-visible List/Table switch for the Analytical dataset option
export const DatasetViewToggle = ({
  view,
  onChange,
  listLabel,
  tableLabel,
}: DatasetViewToggleProps) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={view}
    onChange={(_event, next: DatasetView | null) => {
      // `null` fires when the active button is re-clicked; ignore it so one
      // of the two views always stays selected.
      if (next) onChange(next);
    }}
    aria-label={`${listLabel} / ${tableLabel}`}
    data-testid="analysis-dataset-view-toggle"
  >
    <ToggleButton
      value="list"
      aria-label={listLabel}
      data-testid="analysis-dataset-view-list"
      sx={toggleButtonSx}
    >
      <FormatListBulletedOutlinedIcon sx={{ fontSize: 18, mr: 2 }} />
      {listLabel}
    </ToggleButton>
    <ToggleButton
      value="table"
      aria-label={tableLabel}
      data-testid="analysis-dataset-view-table"
      sx={toggleButtonSx}
    >
      <TableChartOutlinedIcon sx={{ fontSize: 18, mr: 2 }} />
      {tableLabel}
    </ToggleButton>
  </ToggleButtonGroup>
);
